import { SidebarMenu } from '@/components/ui-kit/sidebar';
import { MenuItem } from '@/models/sidebar';
import { SidebarMenuItemComponent } from '../sidebar-menu-item/sidebar-menu-Item';
import { cn } from '@/lib/utils';

interface MenuSectionProps {
  title?: string;
  className?: string;
  items: MenuItem[];
  showText: boolean;
  pathname: string;
  onItemClick?: () => void;
  /** Settings block — skip the rail hairline (footer already has a visual break). */
  pinned?: boolean;
}

export const MenuSection = ({
  title,
  className,
  items,
  showText,
  pathname,
  onItemClick,
  pinned = false,
}: Readonly<MenuSectionProps>) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={cn(pinned && 'nav-pinned', className)}>
      {title ? (
        <>
          <p
            className={cn(
              'nav-section px-2.5 pb-1.5 text-xs font-medium uppercase tracking-wide text-neutral-500',
              !showText && 'hidden',
              'group-data-[collapsible=icon]:hidden'
            )}
          >
            {title}
          </p>
          {/* Hairline stands in for the section heading in the icon rail. */}
          <div
            aria-hidden
            className={cn(
              'nav-rule mx-auto my-2.5 hidden h-px w-6 bg-[#E7E8EA]',
              'group-data-[collapsible=icon]:block',
              pinned && 'group-data-[collapsible=icon]:!hidden'
            )}
          />
        </>
      ) : null}

      <SidebarMenu className="gap-1">
        {items.map((item) => (
          <SidebarMenuItemComponent
            key={item.id}
            item={item}
            showText={showText}
            isActive={pathname.includes(item.path)}
            onClick={onItemClick}
          />
        ))}
      </SidebarMenu>
    </div>
  );
};
